import { TraceKeyResponseTypeEnum } from '@ulysses-inc/harami_api_client'
import { ReactNode } from 'react'
import DateSvg from 'src/assets/icons/date.svg?react'
import MultipleChoiceSetSvg from 'src/assets/icons/multiple_choice_set.svg?react'
import TextSvg from 'src/assets/icons/text.svg?react'

export type ResponseTypeOption = {
  value: TraceKeyResponseTypeEnum
  label: string
  icon: ReactNode
}

export const RESPONSE_TYPE_OPTIONS: ResponseTypeOption[] = [
  {
    value: TraceKeyResponseTypeEnum.ResponseSet,
    label: 'セット選択肢',
    icon: <MultipleChoiceSetSvg width={24} height={24} />,
  },
  {
    value: TraceKeyResponseTypeEnum.Text,
    label: 'テキスト',
    icon: <TextSvg width={24} height={24} />,
  },
  {
    value: TraceKeyResponseTypeEnum.Date,
    label: '日時',
    icon: <DateSvg width={24} height={24} />,
  },
]
